export const FormOrFormExperienceType = [ "MarketoForm", "FormExperience" ] as const;
export type FormOrFormExperienceType = typeof FormOrFormExperienceType[ number ];